import React, { PropsWithChildren, useEffect, useState } from 'react';
import { createContext } from 'react';

export const useUserActivationCheck = () => {
  const [focused, setFocused] = useState(document.hasFocus());

  useEffect(() => {
    const handleFocus = () => setFocused(true);
    const handleBlur = () => setFocused(false);
    window.addEventListener('focus', handleFocus);
    window.addEventListener('blur', handleBlur);
    document.addEventListener('mouseenter', handleFocus);
    document.addEventListener('mouseleave', handleBlur);
    return () => {
      window.removeEventListener('focus', handleFocus);
      window.removeEventListener('blur', handleBlur);
      document.removeEventListener('mouseenter', handleFocus);
      document.removeEventListener('mouseleave', handleBlur);
    };
  }, []);

  /** Returns `true` after specific user-generated events, including:
   * - Mouse interactions: Click, double-click, right-click, and similar actions where the user physically interacts with the page.
   * - Keyboard interactions: Pressing any key on the keyboard, which signifies the user's intent to interact.
   * - Touch interactions: Taps, swipes, and other touch gestures on touchscreen devices.
   */

  // for some stupid reason the unit-tests don't recognize Navigator.userActivation
  // so I had to add the any type :(  
  // TODO: remove in the future, but make sure the unit-tests pass first
  const isActive = (navigator as any).userActivation?.isActive ?? true;
  return isActive || ((navigator as any).userActivation?.hasBeenActive && focused);
};

export const userActivationContext = createContext<boolean>(undefined);

export const UserActivationContextProvider: React.FC<PropsWithChildren> = (
  props
) => {
  const isUserActive = useUserActivationCheck();
  return (
    <userActivationContext.Provider value={isUserActive}>
      {props.children}
    </userActivationContext.Provider>
  );
};
